import {
  isDefaultProjectSortConditions,
  isProjectSortColumnId,
  type ProjectSortColumnId,
} from '@/entities/project/lib/sort-fields';
import { parseSortConditions as parseSortConditionsBase } from '@/shared/lib/sort/parseSortConditions';
import type { SortCondition, SortOrder } from '@/shared/lib/sort/types';

/**
 * URL search params から歳出比較の並び替え条件を組み立てる。
 * 歳出比較は URL を `sort[]` + `order[]` の 2 配列で表現する（事業一覧の `sort[]` 1 本とは別形式）。
 */
export const parseSortConditions = (
  sortBy: readonly string[] | undefined,
  sortOrder: readonly string[] | undefined,
): SortCondition<ProjectSortColumnId>[] =>
  parseSortConditionsBase({ sortBy, sortOrder, isColumnId: isProjectSortColumnId });

/**
 * 並び替え条件を URL search params（`sort[]` / `order[]`）に変換する。
 *
 * 条件なし、または UI 既定（`DEFAULT_PROJECT_SORT_CONDITIONS`）と完全一致する場合は
 * URL からキーを削除して BE 既定順に委ねる（`undefined` を返す）。
 * 年度明細（base）・差分（ai）の両タブで共通利用する。
 */
export const toAssessmentSortSearchParams = (
  conditions: SortCondition<ProjectSortColumnId>[],
): { sort: ProjectSortColumnId[] | undefined; order: SortOrder[] | undefined } => {
  const isDefault = conditions.length === 0 || isDefaultProjectSortConditions(conditions);
  return {
    sort: isDefault ? undefined : conditions.map((c) => c.columnId),
    order: isDefault ? undefined : conditions.map((c) => c.order),
  };
};
